import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import AdminValidation from "../../../components/adminvalidation/AdminValidation";
import AdminClientValidationStats from "../clientValidationStats/AdminClientValidationStats";
import styles from "./AdminOrganizations.module.scss";

const { Title, Paragraph } = Typography;

const AdminOrganizations = () => {
  const { t } = useTranslation();

  return (
    <AdminValidation>
      <div className={styles.wrapper}>
        <Title level={2}>{t("AdminOrganizations-Title")}</Title>
        <Paragraph type="secondary">
          {t("AdminOrganizations-Description")}
        </Paragraph>
        <AdminClientValidationStats embedded />
      </div>
    </AdminValidation>
  );
};

export default AdminOrganizations;
